module.exports = __webpack_public_path__ + "static/media/svi-bg2.0e531e88.png";